export default __webpack_public_path__ + "static/media/front-card.ba11241c.svg";